import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'

Vue.use(Router)

export default new Router({
  routes: [

    {
      path: '/login',
      name: 'login',
      component: () => import("../components/login"),
      meta: {title: "登录"}
    },
    {
      path: '/Download',
      name: 'Download',
      component: () => import("../components/Download"),
      meta: {title: "证书下载"}
    },


    {
      path: '*',
      redirect: "/Index"
    },
    {
      path: '/',
      redirect: "/Index",
      component: () => import("../components/Index"),
      meta: {title: "主页"}
    },
    {
      path: '/Index',
      name: 'index',
      component: () => import("../components/Index"),
      meta: {title: "主页"}
    },
    {
      path: '/vfooter',
      name: 'footer',
      component: () => import("../components/footer/footer"),
      meta: {title: "底部"}
    },
    {
      path: '/check',
      name: 'check',
      component: () => import("../components/check/check"),
      meta: {title: "验证"}
    },{
      path: '/checkPage',
      name: 'checkPage',
      component: () => import("../components/check/checkPage"),
      meta: {title: "验证输入"}
    },
    {
      path: '/news',
      name: 'news',
      component: () => import("../components/information/news"),
      meta: {title: "资讯中心"}
    },
    {
      path: '/newsDetial',
      name: 'newsDetial',
      component: () => import("../components/information/newsDetial"),
      meta: {title: "资讯中心详情"}
    },

    {
      path: '/newsDetial1',
      name: 'newsDetial1',
      component: () => import("../components/information/newsDetial"),
      meta: {title: "资讯中心详情"}
    },
    {
      path: '/aboutus',
      name: 'aboutus',
      component: () => import("../components/aboutus/aboutus"),
      meta: {title: "走进华验"}
    },
    {
      path: '/align',
      name: 'align',
      component: () => import("../components/ourservice/align"),
      meta: {title: "计量校准"}
    },
    {
      path: '/consult',
      name: 'consult',
      component: () => import("../components/ourservice/consult"),
      meta: {title: "验证咨询"}
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js